import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  background-color: #ffffff;
`;

export const MainContent = styled.div`
  flex-grow: 1;
  height: 100vh;
  overflow: auto;
`;
